import React, { PropsWithChildren } from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import { Typography } from "@material-ui/core"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginBottom: 24,
      color: "rgba(0, 0, 0, .87)",
      fontSize: 26,
      fontWeight: 700,
      letterSpacing: "-1px",
      [theme.breakpoints.up("md")]: {
        fontSize: 48,
      },
    },
  })
)
export default function SectionTitle({ children }: PropsWithChildren<{}>) {
  const classes = useStyles()
  return <Typography className={classes.root}>{children}</Typography>
}
